<template>
  <div class="hello">
    <h1>{{ title }}</h1>
    <h6 v-if="!authenticated">{{ msg }}</h6><!-- broken -->
  </div>
</template>

<script>
  export default {
    name: 'hello',
    data () {
      return {
        title: '',
        msg: '',
        tenant_full_name: ''
      }
    },
    computed: {
      formIsValid () {
        return /[\S]+/.test(this.username)
      },
      authenticated () {
        return this.$store.getters.cognitoAuthenticated
      },
      updateMsg () {
        let msg = 'Please log in to access files shared with you'
        if (this.tenant_full_name !== '') {
          msg = msg + ' from ' + this.tenant_full_name + '.'
        }
        this.msg = msg
      },
      updateTitle () {
        let title = 'File Portal'
        /*
        if (this.tenant_full_name !== '') {
          title = this.tenant_full_name + ' ' + title
        }
        */
        this.title = title
      },
      updateTenant () {
        if (this.$store.state.tenant_full_name !== undefined) {
          this.tenant_full_name = this.$store.state.tenant_full_name
        }
        this.updateTitle
        this.updateMsg
      }
    },
    mounted () {
      this.updateTenant
      this.authenticated
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue?4f97edc6